import React from 'react';
import { Disclosure, Transition } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/24/outline';
import { FAQItem } from '../../data/faqData';

interface FAQSectionProps {
  title: string;
  icon: React.ComponentType<{ className?: string }>;
  items: FAQItem[];
}

const FAQSection: React.FC<FAQSectionProps> = ({ title, icon: Icon, items }) => {
  return (
    <div className="bg-white rounded-2xl shadow-sm overflow-hidden">
      <div className="px-6 py-5 border-b border-gray-200">
        <h2 className="text-xl font-semibold text-gray-900 flex items-center">
          <Icon className="h-6 w-6 text-airbnb-red mr-3" />
          {title}
        </h2>
      </div>
      
      <div className="divide-y divide-gray-200">
        {items.map((item) => (
          <Disclosure key={item.id} as="div">
            {({ open }) => (
              <>
                <Disclosure.Button className="w-full px-6 py-4 text-left flex justify-between items-center hover:bg-gray-50 transition-colors duration-200">
                  <span className="text-base font-medium text-gray-900">
                    {item.question}
                  </span>
                  <ChevronDownIcon
                    className={`${
                      open ? 'transform rotate-180' : ''
                    } h-5 w-5 text-gray-500 transition-transform duration-200`}
                  />
                </Disclosure.Button>
                
                <Transition
                  enter="transition duration-100 ease-out"
                  enterFrom="transform scale-95 opacity-0"
                  enterTo="transform scale-100 opacity-100"
                  leave="transition duration-75 ease-out"
                  leaveFrom="transform scale-100 opacity-100"
                  leaveTo="transform scale-95 opacity-0"
                >
                  <Disclosure.Panel className="px-6 py-4 bg-gray-50">
                    <div className="text-base text-gray-600 prose max-w-none">
                      {item.answer}
                    </div>
                  </Disclosure.Panel>
                </Transition>
              </>
            )}
          </Disclosure>
        ))}
      </div>
    </div>
  );
};

export default FAQSection;